import React from "react";
import { AccessDenied, ErrorState } from "../../../shared-ui/States";
import BrandLogo from "../../../shared-ui/BrandLogo";
import platformLogo from "../../../assets/branding/cranesoftwares-logo.png";
import "../../../shared-ui/crane-tokens.css";

/** Stitch access-denied / error surfaces — driven by real authz, not simulated. */
export function AccessDeniedPage() {
  return (
    <div style={{ padding: 48, maxWidth: 560, margin: "40px auto" }}>
      <BrandLogo src={platformLogo} size="md" alt="CraneSoftwares" />
      <div style={{ marginTop: 24 }}>
        <AccessDenied />
      </div>
    </div>
  );
}

export function ServerErrorPage({ onRetry }) {
  return (
    <div style={{ padding: 48, maxWidth: 560, margin: "40px auto" }}>
      <BrandLogo src={platformLogo} size="md" alt="CraneSoftwares" />
      <div style={{ marginTop: 24 }}>
        <ErrorState onRetry={onRetry} />
      </div>
    </div>
  );
}

export default AccessDeniedPage;
